import { Component, Input } from '@angular/core';
import { RootMenuItem } from 'src/models/Menu';
import { CurrentUIState } from 'src/models/UIState';
import { TranslateModule } from '@ngx-translate/core';
import { DesktopMenuItemComponent } from '../../ui/desktop-menu-item/desktop-menu-item.component';


@Component({
    selector: 'asg-dropdown',
    templateUrl: './dropdown.component.html',
    styleUrls: ['./dropdown.component.scss'],
    standalone: true,
    imports: [DesktopMenuItemComponent, TranslateModule]
})

export class DropdownComponent {
  @Input() image: string;
  @Input() title: string | undefined;
  @Input() items: RootMenuItem[];
  @Input() uiState: CurrentUIState & { [key: string]: any } | null = null;
  @Input() id: string;
  @Input() parentId: string | undefined;
  private defaultContainerStyle: string = 'has-menu-dropdown';

  constructor() {}

  clicked(): void {
    const container = document.getElementById(this.id);
    if (container) {
      container.className = container.className === this.defaultContainerStyle ?
      this.getHoverTouchScreenStyle() : this.defaultContainerStyle;
      this.closeCompetingDropdowns();
    }
  }

  closeDropdown(): void {
    const container = document.getElementById(this.id);
    if (container) {
      // should be open, but let's check anyway
      if (container.className !== this.defaultContainerStyle) {
        // close it
        this.clicked();

        // if there is a parent, close the parent dropdown
        this.closeParentDropdown();
      }
    }
  }

  private getHoverTouchScreenStyle(): string {
    return `${this.defaultContainerStyle} ${this.parentId ? 'has-menu-dropdown-child' : 'hover_touchScreen'}`;
  }

  private closeCompetingDropdowns(): void {
    const dropdowns = document.querySelectorAll(`.${this.defaultContainerStyle}`);
    dropdowns.forEach(dropdown => {
      // don't close itself
      // if this dropdown has a parent, don't close that parent
      if (this.id === dropdown.id
        || this.parentId && dropdown.id === this.parentId)
      {
          return
      }
      // close all other dropdowns
      if (dropdown.className !== this.defaultContainerStyle) {
        dropdown.className = this.defaultContainerStyle;
      }
    })
  }

  private closeParentDropdown(): void {
    if (this.parentId) {
      const parent = document.getElementById(this.parentId);
      if (parent && parent.className !== this.defaultContainerStyle) {
        parent.className = this.defaultContainerStyle;
      }
    }
  }
}
